<template>
  <base-create
          :title="title"
          :fields="fields"
          :resourceName="resourceName"
          :breadcrumbs="breadcrumbs"
  >
  </base-create>
</template>

<script>
  import Conditions from '../../components/field/conditions';

  export default {
    components: {
      Conditions
    },
    data() {
      const commonColumns = [
        {
          label: "お知らせ公開(予定)日時",
          name: "publish_at",
          type: "custom",
          rules: "required",
          width: "60%"
        },
        {
          label: "配信ユーザー指定(絞込)",
          name: "conditions",
          type: "conditions"
        },
        {
          label: "アンケートor商品レビュー",
          name: "notification_type",
          type: "select",
          rules: "required",
          textKey: "label",
          valueKey: "value",
          optionType: "common/reminder_types"
        },
        {
          label: "アンケート選択",
          name: "questionnaire_id",
          type: "select",
          rules: "required",
          textKey: "label",
          valueKey: "value",
          optionType: "common/questionnaires"
        },
        {
          label: "アンケートURL",
          name: "questionnaire_url",
          width: "100%"
        },
        {
          label: "商品ID",
          name: "product_id",
          rules: "required",
          width: "100%"
        },
        {
          label: "担当者",
          name: "administrator_id",
          type: "select",
          rules: "required",
          textKey: "label",
          valueKey: "value",
          optionType: "common/provider_administrators"
        },
        {
          label: "テンプレート選択",
          name: "reminder_template_id",
          type: "select",
          textKey: "label",
          valueKey: "value",
          optionType: "common/reminder_templates"
        },
        {
          label: "お知らせタイトル",
          name: "title",
          rules: "required|max:255",
          width: "100%"
        },
        {
          label: "お知らせ本文",
          name: "body",
          type: "textarea",
          rules: "required",
          width: "100%"
        }
      ];

      return {
        title: "新規登録",
        resourceName: "reminders",
        fields: commonColumns
      }
    },
    computed: {
      breadcrumbs() {
        return [
          {
            text: "アンケートと商品レビュー催促一覧",
            disabled: false,
            to: `/${this.resourceName}`
          },
          {
            text: "アンケートと商品レビュー催促",
            disabled: true
          }
        ];
      },
      isProvider() {
        return this.$store.getters[`auth/isProvider`];
      }
    }
  };
</script>
